import { useTranslate } from "@similarweb/i18n-provider";

import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";
import { ZERO } from "app/pages/activation/components/HomeWithData/ShareData/constants";

import type { IRankTrackerWidgetData } from "../../types";

import * as SC from "./styles";
import { RANKS_WOW } from "./texts";

interface IDefaultSchema {
    data: IRankTrackerWidgetData;
}

const Default = ({ data }: IDefaultSchema) => {
    const { translate } = useTranslate();
    const { avgPosition, changeRanksWoW } = data;
    const isIncreasing = changeRanksWoW > ZERO;
    const isNotChanged = changeRanksWoW === ZERO;
    const changeLabel = translate(RANKS_WOW, { value: Math.abs(changeRanksWoW).toFixed(1) });

    return (
        <SC.Container>
            <SC.LeftSection>
                <SC.MainValue>{avgPosition.toFixed(1)}</SC.MainValue>

                {!isNotChanged ? (
                    <SC.ChangeChip>
                        <ChangeIndication
                            className="customChangeIndication"
                            changeValue={changeLabel}
                            isIncreasing={isIncreasing}
                            isNotChanged={isNotChanged}
                        />
                    </SC.ChangeChip>
                ) : null}
            </SC.LeftSection>
        </SC.Container>
    );
};

export default Default;
